import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/mine-steder")({
	beforeLoad: () => {
		throw redirect({ to: "/account/steder" });
	},
});
